import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import type { State } from "@App/state";

export const UserIdProtectedRoutes = () => {
  const userId = useSelector((state: State) => state.auth.userId);
  // get the current route to redirect to after login
  const currentLocation = useLocation();
  const isValidUuidV4 = (uuid: string): boolean => {
    const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    return uuidRegex.test(uuid);
  };

  return isValidUuidV4(userId) ? (
    <Outlet />
  ) : (
    <Navigate to="/partner/myald/login" state={{ location: currentLocation }} />
  );
};
